// extracted by mini-css-extract-plugin
module.exports = {"title":"ErrorPage_title_3AfzB","description":"ErrorPage_description_OUYT_","back_btn":"ErrorPage_back_btn_1GOb2"};